export const base64toBlob = (data: string, contentType: string) => {
  const base64WithoutPrefix = data.substring(
    `data:${contentType};base64,`.length
  );

  const bytes = atob(base64WithoutPrefix);
  let length = bytes.length;
  const out = new Uint8Array(length);

  while (length--) {
    out[length] = bytes.charCodeAt(length);
  }

  return new Blob([out], { type: contentType });
};
